import React from 'react';
import styled from 'styled-components';

const TeamSection = styled.section`
  padding: 5rem 0;
  background-color: var(--background-white);
`;

const SectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.h2`
  font-family: 'Libre Baskerville', serif;
  font-size: 2.5rem;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 1rem;
`;

const SectionSubtitle = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 1.1rem;
  color: var(--text-dark);
  text-align: center;
  max-width: 600px;
  margin: 0 auto 3rem;
  line-height: 1.6;
`;

const DentistCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 3rem;
  margin-bottom: 3rem;

  &:last-child {
    margin-bottom: 0;
  }

  &:nth-child(even) {
    flex-direction: row-reverse;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;

    &:nth-child(even) {
      flex-direction: column;
    }
  }
`;

const PhotoWrapper = styled.div`
  flex-shrink: 0;
  width: 280px;
  height: 340px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
  }

  @media (max-width: 768px) {
    width: 240px;
    height: 300px;
  }
`;

const BioContent = styled.div`
  flex: 1;
`;

const DentistName = styled.h3`
  font-family: 'Libre Baskerville', serif;
  font-size: 1.6rem;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
`;

const DentistTitle = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 0.95rem;
  color: var(--accent-color);
  font-weight: 600;
  margin-bottom: 1.25rem;
`;

const BioText = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 1rem;
  color: var(--text-dark);
  line-height: 1.8;
  margin-bottom: 1rem;
`;

const Team = () => {
  return (
    <TeamSection id="team">
      <SectionContainer>
        <SectionTitle>Meet Our Dentists</SectionTitle>
        <SectionSubtitle>
          Get to know the experienced professionals behind your care at Finch & Dudley Dental.
        </SectionSubtitle>

        <DentistCard>
          <PhotoWrapper>
            <img src="/images/dr-siddiqi.png" alt="Dr. Faiza Siddiqi" loading="lazy" />
          </PhotoWrapper>
          <BioContent>
            <DentistName>Dr. Faiza Siddiqi</DentistName>
            <DentistTitle>General Dentist</DentistTitle>
            <BioText>
              Dr. Faiza Siddiqi graduated in 2012 from Dalhousie University Dental School. She grew up on the East Coast in Nova Scotia. Having also been accepted into the University of Toronto, she had no idea life would still bring her here to Toronto! She is now happy to call North York home.
            </BioText>
            <BioText>
              Dr. Siddiqi is committed to continuing education and regularly takes courses to stay up to date on the latest innovations in dentistry. She is an active member of the Ontario Dental Association, Canadian Dental Association and the RCDSO. Dr. Siddiqi strongly believes in preventative care and the importance of oral hygiene. She has a great compassion for her patients and aims to provide them with a calm, comfortable dental experience.
            </BioText>
            <BioText>
              In her spare time, Dr. Siddiqi enjoys spending time with her husband and their two young boys. They enjoy exploring the city, going to parks and travelling the world whenever possible!
            </BioText>
          </BioContent>
        </DentistCard>

        <DentistCard>
          <PhotoWrapper>
            <img src="/images/dr-khan.webp" alt="Dr. Waji Khan" loading="lazy" />
          </PhotoWrapper>
          <BioContent>
            <DentistName>Dr. Waji Khan</DentistName>
            <DentistTitle>Implant & Sedation Dentist</DentistTitle>
            <BioText>
              A University of Toronto–trained dentist and former Canadian Forces dental officer, Dr. Khan brings a rare combination of academic depth, military precision, and genuine patient focus to every appointment.
            </BioText>
            <BioText>
              With clinical expertise spanning dental implants, sedation dentistry, oral surgery, and restorative care, Dr. Khan takes a comprehensive, long-term approach to oral health — always grounded in clear communication and individualized treatment planning.
            </BioText>
          </BioContent>
        </DentistCard>
      </SectionContainer>
    </TeamSection>
  );
};

export default Team;
